import { render, staticRenderFns } from "./DoAndDont.vue?vue&type=template&id=1ed6b374&"
import script from "./DoAndDont.vue?vue&type=script&lang=js&"
export * from "./DoAndDont.vue?vue&type=script&lang=js&"
import style0 from "./DoAndDont.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports